import classNames from 'classnames';
import { ROUTES } from '@/constants';
import type { ProductCatalog } from '@/interfaces/strapi';
import { generatePath, Link } from 'react-router-dom';
import CTNIcon from '@ctn/ui/components/ctn-icon/icon';
import CTNButton from '@ctn/ui/components/ctn-button';

type CatalogProductDetailProps = {
	readonly className?: string;
	readonly product: ProductCatalog;
};

const classNameComponent = 'c-cnm-catalog-product-detail';

export const CatalogProductDetail = ({ className, product }: CatalogProductDetailProps) => {
	const wrapperClassName = classNames(classNameComponent, className);
	return (
		<section className={wrapperClassName}>
			<Link to={ROUTES.ACADEMIA_MATRITENSE_CATALOGO} className={`${classNameComponent}__back`}>
				<CTNIcon icon="arrowLeft" size="size-16" />
				<span>Atrás</span>
			</Link>
			<div className={`${classNameComponent}__content`}>
				<h3 className={`${classNameComponent}__title`}>{product.name}</h3>

				<div className={`${classNameComponent}__grid`}>
					<div className={`${classNameComponent}__image`}>
						<img src={product.image.url} alt={product.image.alt} />
					</div>

					<div className={`${classNameComponent}__info`}>
						<div className={`${classNameComponent}__info-row`}>
							<span>Autor</span>
							<p>{product.author}</p>
						</div>

						<div className={`${classNameComponent}__info-row`}>
							<span>Editorial</span>
							<p>{product.editorial}</p>
						</div>

						<div className={`${classNameComponent}__info-row`}>
							<span>Año de publicación</span>
							<p>{product.year}</p>
						</div>

						<div className={`${classNameComponent}__info-row`}>
							<span>ISBN</span>
							<p>{product.isbn}</p>
						</div>

						<div className={`${classNameComponent}__info-row`}>
							<span>Materias</span>
							<p>{product.category.name}</p>
						</div>

						<div className={`${classNameComponent}__info-row`}>
							<span>Precio</span>
							<p className={`${classNameComponent}__price`}>{product.price.toFixed(2)} €</p>
						</div>

						<div className={`${classNameComponent}__info-row`}>
							<Link
								to={generatePath(ROUTES.ACADEMIA_MATRITENSE_CATALOGO_SOLICITAR, {
									category: product.category.slug,
									product: product.slug,
								})}
							>
								<CTNButton
									type="button"
									variant="solid"
									mode="primary"
									className={`${classNameComponent}__btn`}
									label="Solicitar Libro"
								/>
							</Link>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};
